<div *ngIf='items'>
  <ol class="result-list">
    <li class="result-list__item" [attr.data-number]='getItemNumber(i)'
      *ngFor='let item of items | paginate: paginateOptions; let i = index'>
      <app-button [data]="{type: 0, name: item.title, url: item.url}"></app-button>
      <p class=result-list__text [innerHTML]='item.description'></p>
    </li>
  </ol>

  <pagination-controls (pageChange)="onPageChange($event)"></pagination-controls>
</div>
